export interface ContentResponseType {
  resultType: ResultType;
}

export enum ResultType {
  USER_TEXT = 'user_text',
  TEXT = 'text',
  SHOP = 'shop',
  SHOP_RECOMMENDATIONS = 'shopRecommendations'
}
